(function () {
    'use strict';

    angular.module('core')
        .service('IEFallbackService', function () {
            return {
                upload: function (uploadUrl, inputElement, onSuccess) {
                    var iframe = document.createElement('iframe');
                    iframe.setAttribute('id', 'IEupload');
                    iframe.setAttribute('name', 'IEupload');
                    iframe.setAttribute('width', '0');
                    iframe.setAttribute('height', '0');
                    iframe.setAttribute('border', '0');
                    iframe.setAttribute('src', 'javascript:false;');
                    iframe.style.display = 'none';

                    var form = document.createElement('form');
                    form.setAttribute('target', 'IEupload');
                    form.setAttribute('action', uploadUrl);
                    form.setAttribute('method', 'post');
                    form.setAttribute('enctype', 'multipart/form-data');
                    form.setAttribute('encoding', 'multipart/form-data');
                    form.style.display = 'block';

                    form.appendChild(inputElement);

                    document.body.appendChild(form);
                    document.body.appendChild(iframe);
                    var iframeFile = document.getElementById('IEupload');

                    var uploadHandler = function () {
                        if (iframeFile.detachEvent) {
                            iframeFile.detachEvent('onload', uploadHandler);
                        } else {
                            iframeFile.removeEventListener('load', uploadHandler, false);
                        }
                        onSuccess();
                    }

                    if (angular.isDefined(onSuccess)) {
                        if (iframeFile.addEventListener) {
                            iframeFile.addEventListener('load', uploadHandler, true);
                        } else if (iframeFile.attachEvent) {
                            iframeFile.attachEvent('onload', uploadHandler);
                        }
                    }

                    form.submit();
                }
            };
        });

})();
